import React, { createContext, useContext, ReactNode } from 'react';

interface StoreIdContextType {
  storeId: string | undefined;
}

const StoreIdContext = createContext<StoreIdContextType | undefined>(undefined);

export function StoreIdProvider({ children, storeId }: { children: ReactNode; storeId?: string }) {
  return <StoreIdContext.Provider value={{ storeId }}>{children}</StoreIdContext.Provider>;
}

export function useStoreId() {
  const context = useContext(StoreIdContext);
  if (context === undefined) {
    throw new Error('useStoreId must be used within a StoreIdProvider');
  }
  return context;
}

export function useStoreIdSafe() {
  return useContext(StoreIdContext);
}
